module.exports = __webpack_public_path__ + "static/media/blur-close-up-dairy-product-376464.5a462108.png";